import React from "react";
import { CKEditor, useCKEditorCloud } from "@ckeditor/ckeditor5-react";
import baseApi from "../Components/api";
import Config from "./config";
import "./Editor.css";

const LINK_STYLE_ID = "ckeditor-link-dark-blue-style";

const ensureLinkStyles = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(LINK_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = LINK_STYLE_ID;
  style.textContent = `
    .ck.ck-editor .ck-editor__editable a,
    .ck.ck-editor .ck-editor__editable a:link,
    .ck.ck-editor .ck-editor__editable a:visited,
    .ck.ck-editor .ck-editor__editable a span[style],
    .ck.ck-editor .ck-content a,
    .ck.ck-editor .ck-content a span[style] {
      color: #003399 !important;
      -webkit-text-fill-color: #003399 !important;
      text-decoration: underline !important;
    }
    .ck.ck-editor .ck-editor__editable a:hover,
    .ck.ck-editor .ck-editor__editable a:hover span[style],
    .ck.ck-editor .ck-content a:hover {
      color: #001a66 !important;
      -webkit-text-fill-color: #001a66 !important;
    }
  `;
  document.head.appendChild(style);
};

const CKTextEditor = ({ value, onChange }) => {
  const cloud = useCKEditorCloud({
    version: "44.3.0",
    premium: true,
  });

  if (cloud.status === "error") {
    return <div>Error!</div>;
  }

  if (cloud.status === "loading") {
    return <div>Loading...</div>;
  }

  const {
    ClassicEditor,
    Essentials,
    Paragraph,
    Bold,
    Italic,
    Font,
    List,
    Table,
    TableToolbar,
    Heading,
    Link,
    LinkImage,
    BlockQuote,
    Underline,
    Code,
    Alignment,
    SourceEditing,
    Image,
    ImageToolbar,
    ImageUpload,
    MediaEmbed,
    SimpleUploadAdapter,
    PasteFromOffice,
  } = cloud.CKEditor;

  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onReady={() => {
        ensureLinkStyles();
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
      config={{
        licenseKey: Config.auth.CKEditor_Token,
        plugins: [
          Essentials,
          Paragraph,
          Bold,
          Italic,
          Font,
          List,
          Table,
          TableToolbar,
          Heading,
          Link,
          LinkImage,
          BlockQuote,
          Underline,
          Code,
          Alignment,
          SourceEditing,
          Image,
          ImageToolbar,
          ImageUpload,
          MediaEmbed,
          SimpleUploadAdapter,
          PasteFromOffice,
        ],
        toolbar: [
          "undo",
          "redo",
          "|",
          "heading",
          "|",
          "fontFamily",
          "fontBackgroundColor",
          "fontColor",
          "alignment",
          "|",
          "bold",
          "italic",
          "underline",
          "code",
          "|",
          "ImageUpload",
          "mediaEmbed",
          "|",
          "link",
          "insertTable",
          "blockQuote",
          "|",
          "numberedList",
          "bulletedList",
          "|",
          "sourceEditing",
        ],
        image: {
          toolbar: [
            "imageTextAlternative",
            "|",
            "linkImage",
          ],
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1",
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3",
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4",
            },
            {
              model: "heading5",
              view: "h5",
              title: "Heading 5",
              class: "ck-heading_heading5",
            },
            {
              model: "heading6",
              view: "h6",
              title: "Heading 6",
              class: "ck-heading_heading6",
            },
          ],
        },
        simpleUpload: {
          uploadUrl: baseApi + "text-editor/image-upload",
          withCredentials: false,
        },
      }}
    />
  );
};

export default CKTextEditor;
